module.exports = __webpack_public_path__ + "static/media/slider_img1.040f6d88.jpg";